/* eslint-disable no-param-reassign */
import Core6Utilities from "../core6/Core6Utilities";

export default class Core6DraggerCommon {
  static removeDropareas(querySelector) {
    //console.log('removeDropareas');
    //const previewFrame = Core6Utilities.getElement('#previewframe').contentWindow;
    //const dropzoneContainer = previewFrame.document.body.querySelector('.page');

    const dropareas = Core6Utilities.getElementAll(querySelector);
    for (let i = 0, len = dropareas.length; i < len; i += 1) {
      const droparea = dropareas[i];
      if (droparea.classList.contains('core6_no_components')) {
        droparea.classList.remove(querySelector);
      } else {
        droparea.remove();
      }
    }
  }

  static htmlToElement(html) {
    //console.log('COMMON: function htmlToElement');
    const template = document.createElement('template');
    template.innerHTML = html;
    return template.content.firstChild;
  }

  static dragoverComponentHandler(ev) {
    ev.preventDefault();
    ev.dataTransfer.dropEffect = 'copy';
    ev.target.classList.add('over');
  }

  static dragleaveComponentHandler(ev) {
    ev.preventDefault();
    ev.target.innerHTML = '';
    ev.target.classList.remove('over');
  }

  static removeExcessDropareas() {
    const previewFrame = Core6Utilities.getElement('#previewframe').contentWindow;
    const dropzoneContainer = previewFrame.document.body.querySelector('.page');

    const dropzoneContainers = dropzoneContainer.querySelectorAll('.row_content_container');
    if (dropzoneContainers.length === 0) {
      return;
    }

    // Loop through the containers
    for (let i = 0, len = dropzoneContainers.length; i < len; i += 1) {
      const dropzoneContainer1 = dropzoneContainers[i];
      const columns = dropzoneContainer1.querySelectorAll('.core6-mainrow-container:not(.isTemplate) .row_content_container > div[class^="col-md-"]');

      // Loop through the columns
      for (let x = 0, len2 = columns.length; x < len2; x++) {
        const column = columns[x];

        const components = column.querySelectorAll('.row_content_container > div[class^="col-md-"] > div');
        if (components.length === 0) {
          column.innerHTML = '<div class="core6_no_components component_droparea" style="display: inline-block;" data-component-dz-new-index="0"></div>';
        } else if (components.length === 1) {
          // Do nothing
        } else {
          const col = column.querySelector('.row_content_container > div[class^="col-md-"] > div.core6_no_components');
          if (col !== null && col !== undefined) {
            col.remove();
          }
        }
      }
    }
  }
}



// WEBPACK FOOTER //
// ./resources/assets/js/core6_dragger/Core6DraggerCommon.js